import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { releaseActivity } from './api';
import { QueryKey } from '../QueryKey';
import { goToErrorPage } from 'utils';

export default function usePostReleaseActivity(activityId: number) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    [QueryKey.ACTIVITY, activityId, QueryKey.RELEASE_ACTIVITY],
    () => releaseActivity(activityId),
    {
      onSuccess: data => {
        queryClient.setQueryData([QueryKey.ACTIVITY, activityId], data);
      },
      onError: (error: any) => {
        goToErrorPage(error);
        toast.error(t('message.title.error.release.activity'));
      },
    }
  );

  return { postReleaseActivity: mutateAsync, isLoadingReleaseActivity: isLoading };
}
